var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZeekrLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 40,
    viewBox: "0 0 160 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2793 35.5294H26.5119V23.5651L16.7444 13.8846V3.22684H36.2679L36.2793 35.5294ZM3.72492 35.5294V3.22684H13.4809V15.2139L23.2484 24.8945V35.5181L3.72492 35.5294ZM39.5313 0H0.4729V38.7561H39.5313V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0171 13.0904L59.8947 23.5662H69.4903V25.7023H54.5815V25.657L64.704 15.1924H55.1427V13.0563H70.0285V13.0904H70.0171Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.314 25.7137L123.959 19.1806V25.7137H121.348V13.0563H123.959V19.1463L133.05 13.0563H137.07L127.932 19.101L137.379 25.7023H133.314V25.7137Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.64 25.7137L152.552 20.987H153.869C156.365 20.987 158.552 19.5668 158.552 17.1581V16.9876C158.552 14.5334 156.342 13.0563 153.777 13.0563H143.391V25.7023H146.002V19.101L155.793 25.7023H159.64V25.7137ZM145.991 15.2037H153.823C154.797 15.2037 155.701 15.5901 155.953 16.3741C155.964 16.5103 155.999 16.8399 155.999 17.1694C155.999 17.5102 155.976 17.8397 155.953 17.9647C155.69 18.6578 154.797 19.0782 153.823 19.0782H145.991V15.2037Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1969 23.464V25.7137H77.9485V13.0563H91.1969V15.3061H80.4791V18.0215H90.6359V20.2713H80.4791V23.4527H91.1969V23.464Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.898 23.464V25.7137H99.6494V13.0563H112.898V15.3061H102.18V18.0215H112.337V20.2713H102.18V23.4527H112.898V23.464Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeekrLogoWhite);
export default ForwardRef;